import {SET_NEWS_DATA, ADD_NEWS_DATA} from '../actions/types';

export const newsReducer = (state = {newsData: []} , action) => {
    switch(action.type) {
        case SET_NEWS_DATA:
            return {...state, newsData: action.payload}  || {};
        case ADD_NEWS_DATA:
            return {...state, newsData: [...state.newsData, action.payload]} || {};
        default:
            return state;
    }
}